// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Part } from './part';
import { PartAlias } from './part-alias';
import { PurchaseOrder } from './purchase-order';
import { PurchaseOrderLineItem } from './purchase-order-line-item';
import { PurchaseOrderLineReceiving } from './purchase-order-line-receiving';
import { PurchaseOrderLineStatus } from './purchase-order-line-status';
import { PurchaseOrderPickUpLine } from './purchase-order-pick-up-line';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get lineTotal() {
        return this.quantity * this.cost;
    }

    get pickUpQuantityScheduled() {
        const outstandingPickUpQty = _(this.pickUps?.filter((pickup) => !pickup.deleted && !pickup.completed))?.sumBy((p) => p.quantity) ?? 0;
        return outstandingPickUpQty + (this.quantityReceived ?? 0);
    }

    get quantityOutstanding() {
      return this.quantity - this.quantityReceived
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  cost!: number;
  description?: string;
  lineNumber!: number;
  mfgDescription?: string;
  mfgPartNumber?: string;
  note?: string;
  packageQuantity?: string;
  partAliasId?: number;
  partId?: number;
  partNumber?: string;
  purchaseOrderId!: number;
  purchaseOrderLineItemId?: number;
  quantity!: number;
  quantityBackOrdered!: number;
  quantityReceived!: number;
  statusId?: number;
  part!: Part;
  partAlias!: PartAlias;
  pickUps!: PurchaseOrderPickUpLine[];
  purchaseOrder!: PurchaseOrder;
  purchaseOrderLineItem!: PurchaseOrderLineItem;
  receivings!: PurchaseOrderLineReceiving[];
  status!: PurchaseOrderLineStatus;
}

